//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Command } from "ckeditor5";

export default class InsertCustomTemplateCommand extends Command {
  execute({ template } = {}) {
    template = template || this.value;
    if (!template) {
      console.error("No template given for insert");
      return;
    }
    const documentFragment = this.editor.data.parse(template);
    this.editor.model.insertContent(documentFragment);
  }

  refresh() {
    const model = this.editor.model;
    if (!model || !model.document || !model.document.selection) {
      return false;
    }
    this.isEnabled = model.document.selection.isCollapsed;
  }
}
